import { Box, Card, Flex, Text } from '@backstage/ui';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';

type Props = {
  title: string;
  description: string;
  target?: string;
  href: string;
};

export const HomePageCard = ({ title, description, target, href }: Props) => (
  <Card
    href={href}
    target={target}
    rel={target === '_blank' ? 'noopener noreferrer' : undefined}
    label={title}
    style={{ border: '1px solid var(--bui-border-1)', padding: '24px 16px' }}
  >
    <Flex align="center" gap="4">
      <Box minWidth="0" style={{ flex: '1 1 0%' }}>
        <Flex direction="column" gap="1_5">
          <Text as="h3" variant="body-large" weight="bold">
            {title}
          </Text>
          <Text as="p" variant="body-small">
            {description}
          </Text>
        </Flex>
      </Box>
      <ArrowForwardIcon fontSize="small" style={{ flexShrink: 0 }} />
    </Flex>
  </Card>
);
